import React from "react";

const CloneIcon = (props) => (
    <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M16.9638 8.98209C16.9614 6.03194 16.9168 4.50384 16.0579 3.45753C15.8921 3.25546 15.7068 3.07019 15.5048 2.90436C14.4009 1.99854 12.761 1.99854 9.48093 1.99854C6.20095 1.99854 4.56096 1.99854 3.45714 2.90436C3.25506 3.07018 3.06977 3.25546 2.90393 3.45753C1.99805 4.56128 1.99805 6.20116 1.99805 9.48091C1.99805 12.7607 1.99805 14.4005 2.90393 15.5043C3.06976 15.7063 3.25506 15.8916 3.45714 16.0574C4.50352 16.9162 6.03173 16.9608 8.98207 16.9632"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M14.0282 9.02455L16.9939 8.98193M14.0142 22.0013L16.9798 21.9586M21.9715 14.0221L21.9435 16.9818M9.01027 14.0357L8.9823 16.9953M11.4872 9.02455C10.6544 9.17371 9.31775 9.32713 9.01027 11.0488M19.4945 21.9586C20.3295 21.8223 21.6684 21.6894 22.0024 19.9726M19.4945 9.02455C20.3273 9.17371 21.664 9.32713 21.9715 11.0488M11.4999 21.9573C10.6671 21.8086 9.33033 21.6559 9.02191 19.9344"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default CloneIcon;

